export default "__VITE_ASSET__9KQSOCZZ__"